module.exports = __webpack_public_path__ + "img/scheduling-w.f111bc4b.svg";